import { render, staticRenderFns } from "./LargeInlineImageModule.vue?vue&type=template&id=12c52bf1&"
import script from "./LargeInlineImageModule.ts?vue&type=script&lang=ts&"
export * from "./LargeInlineImageModule.ts?vue&type=script&lang=ts&"
import style0 from "./LargeInlineImageModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports